import { IResale } from '~/modules/resales/interfaces/IResale';

export function getUserWhitelabelResale(resale: IResale): IResale {
  return Object.values(resale?.whiteLabel || {}).length > 0
    ? resale.whiteLabel
    : resale || ({} as IResale);
}
